import request from "superagent";

import { createQueryParams } from "common/createQueryParams";
import { getTabToken } from "common/MetaActions";
import config from "config/config";
import {
  Counts,
  CustomerDocuments,
  CustomerDocumentsParams
} from "models/customers/documents";

export class SkickaDocumentsAPI {
  static async fetchCustomerDocuments(
    customerId: string,
    params: CustomerDocumentsParams
  ): Promise<CustomerDocuments> {
    const response = await request
      .get(config.api.documents.get(customerId, createQueryParams(params)))
      .set("Authorization", `Bearer ${getTabToken()}`);

    const result: CustomerDocuments = response.body;

    return result;
  }

  static async fetchDocumentsCount(customerId: string): Promise<Counts> {
    const response = await request
      .get(config.api.documents.count(customerId))
      .set("Authorization", `Bearer ${getTabToken()}`);

    return response.body as Counts;
  }
}
